import {Button, Input} from "antd";
import CopyToClipboardField from "../../copyToClipboardField/CopyToClipboardField";
import CopyToClipboardCode from "../../copyToClipboardCode/CopyToClipboardCode";
import ButtonGroup from "../../forms/buttonGroup/ButtonGroup";
import {useEffect, useState} from "react";
import useUserContext from "../../../hooks/useUserContext";
import {getIntegrationKey} from "../../../api/getIntegrationKey";
import {ConsentIntegrationOptions} from "../ConsentIntegrationSection";
import {setIntegrationKey} from "../../../api/setIntegrationKey";
import useToast from "../../../hooks/useToast";
import {ToastSkin} from "../../../context/ToastContext";
import {getMailchimpListId} from "../../../api/getMailchimpListId";
import {setMailchimpListId} from "../../../api/setMailchimpListId";

interface MailchimpIntegrationFormProps {
    onClose: () => void;
    isConnected: boolean;
    setIsConnected: (newVal: boolean) => void;
}


const MailchimpIntegrationForm = ({ onClose, isConnected, setIsConnected }: MailchimpIntegrationFormProps) => {
    const [selectedHook, setSelectedHook] = useState('email-subscribe');
    const [apiKey, setApiKey] = useState('');
    const [listId, setListId] = useState('');
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();
    const [isLoading, setIsLoading] = useState(false);

    const getInitialApiKey = async () => {
        if(selectedDomain) {
            const apiKeyResponse = await getIntegrationKey(selectedDomain, ConsentIntegrationOptions.MAILCHIMP);
            const listIdResponse = await getMailchimpListId(selectedDomain);
            setApiKey(apiKeyResponse.data || '');
            setListId(listIdResponse.data || '');
        }
    }

    const submitApiKey = async () => {
        if(selectedDomain) {
            setIsLoading(true);
            try {
                const apiKeyResponse = await setIntegrationKey(selectedDomain, ConsentIntegrationOptions.MAILCHIMP, apiKey);
                const listIdResponse = await setMailchimpListId(selectedDomain, listId);
                if (apiKeyResponse.data === 'ok' && listIdResponse.data === 'ok') {
                    showToast({text: 'Api Key and Audience ID were updated successfully!', skin: ToastSkin.approval});
                    setIsConnected(true);
                    onClose();
                } else {
                    showToast({
                        text: 'Api Key or Audience ID failed to be updated, please try again or contact support',
                        skin: ToastSkin.error
                    });
                }
                setIsLoading(false);
            } catch(error: any) {
                setIsLoading(false);
            }
        }
    }

    useEffect(() => {
        getInitialApiKey();
    }, [selectedDomain]);

    return (
        <div className="inner-integration-container">
            <div className="left">
                <div className="title">Create a Mailchimp API Key</div>
                <ul>
                    <li>Log in to your Mailchimp account.</li>
                    <li>Go to Profile → Extras → API Keys</li>
                    <li>Click Create A Key.</li>
                    <li>Give it a label (for example: “Vuelve Integration”) so you recognize it later.</li>
                    <li>Copy the API key</li>
                    <li>Paste it down below</li>
                    <li>Also paste your Audience ID (List ID), you can find it in Audience → All contacts → Settings → Audience name and defaults (Look for “Audience ID”)</li>
                    <li>Submit the Api Key and the Audience ID</li>
                </ul>
                <div className="integration-form">
                    <Input value={apiKey} onChange={(e: any) => setApiKey(e.target.value)} placeholder='Mailchimp API-Key' />
                    <Input value={listId} onChange={(e: any) => setListId(e.target.value)} placeholder='Mailchimp Audience ID' />
                </div>
                <div className="actions">
                    <Button loading={isLoading} type="primary" onClick={submitApiKey}>Submit</Button>
                </div>
            </div>
        </div>
    );
}

export default MailchimpIntegrationForm;